
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" label-position="" :model="queryParam" label-width="120px">
          <el-form-item label="会员名:">
            <el-input v-model="queryParam.childName" placeholder="输入会员名"></el-input>
          </el-form-item>
          <el-form-item label="会员小名:">
            <el-input v-model="queryParam.childPetName" placeholder="输入会员名"></el-input>
          </el-form-item>
          <el-form-item label="家长手机号:">
            <el-input v-model="queryParam.userPhone" maxlength="11" placeholder="输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="日期:">
            <el-date-picker v-model="queryParam.dayTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" />
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh"
          @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查
          询</el-button>
      </div>
    </el-card>
    <el-tabs type="card" style="margin-top: 15px;" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基础游泳服务" name="2">
        <after-class-service-b-s @onServiceOk="onServiceOk" :key="refreeTime" :all-worker="allWorker"
          :data-list="tableDataBs"></after-class-service-b-s>
      </el-tab-pane>
      <el-tab-pane label="亲子游泳服务" name="1">
        <after-class-service-cf @onServiceOk="onServiceOk" :key="refreeTime" :all-worker="allWorker"
          :dataList="tableDataCf"></after-class-service-cf>
      </el-tab-pane>
    </el-tabs>
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="queryParam.pageNum" :page-sizes="queryParam.pageSizes" :page-size="queryParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>

<style scoped>
/deep/ .el-tabs__header {
  width: 60%;
}

/deep/ .el-tabs--card.el-tabs__header {
  border: none;
}

/deep/ .el-tabs--card .el-tabs__header .el-tabs__nav {
  border: none;
}

/deep/ .el-tabs__item {
  height: 36px;
  color: #0e6eba;
  background: #cedef5;
  margin-right: 10px;
  border-radius: 4px;
  line-height: 36px;
  /* 卡片阴影 */
  box-shadow: 0px 0px 16px 4px rgba(238, 56, 35, 0.09);
}

/deep/ .el-tabs__item.is-active {
  color: #ffffff;
  text-align: center;
  background: linear-gradient(120.93deg, #1270b8 3.98%, #5aaeee 100%);
}

/deep/ .el-tabs__active-bar {
  display: none;
}

/deep/ .el-tabs__nav-wrap::after {
  display: none;
}
</style>

<script>


import AfterClassServiceBS from "./components/AfterClassServiceBs";
import AfterClassServiceCf from "./components/AfterClassServiceCf";
import commonUtils from "../../../utils/commonUtils";
import globaldata from "../../../utils/globaldata";
import { queryService } from "../../../api/AfterClassService";
import enumsUtil from "../../../utils/enumsUtil";
import timeUtils from "../../../utils/timeUtils";

export default {
  components: { AfterClassServiceCf, AfterClassServiceBS },
  data() {
    return {

      selectRow: null,
      //查询参数
      queryParam: {

        childName: '',
        childPetName: "",
        userPhone: '', //家长手机号
        dayTime: null,

        //分页查询
        pageNum: 1,//当前第几页
        totalPage: 1, //总共数
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      activeName: '2',
      multipleSelection: [], //选择的表单
      //表单结果
      tableDataBs: [
      ],

      tableDataCf: [
      ],
      allWorker: [],

      refreeTime: "",

      storeLessonCards: [], //店铺所有的课程卡
      lessonCardTemplate: [],



    }
  },
  created() {
    let lett = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        lett.onPressEnter();
      }
    }
    globaldata.getStoreWorkersInfo(this.getStoreWorkersInfo);
  },
  mounted() {

  },

  methods: {
    getStoreWorkersInfo(workers) {


      this.allWorker = workers;

      this.flechList();

    },
    /**
     * 响应enter按钮
     */
    onPressEnter() {
      var _this = this;
      _this.flechList();

    },
    flechList() {
      this.listLoading = true;
      let dayTime;
      if (commonUtils.isObjectNull(this.queryParam.dayTime)) {
        dayTime = null;
      } else {
        dayTime = timeUtils.transDayInt(this.queryParam.dayTime);
      }
      let param = {
        childName: this.queryParam.childName,
        childPetName: this.queryParam.childPetName,
        storeFrontId: globaldata.getAdminStore().storeFrontId,
        lessonTemplateId: this.activeName,
        dayTime: dayTime,
        userPhone: this.queryParam.userPhone,
        pageNum: this.queryParam.pageNum,//当前第几页
        pageSize: this.queryParam.pageSize
      }
      queryService(param).then(response => {
        let date = response.data;
        if (commonUtils.isObjectNull(date)) {
          return;
        }
        this.queryParam.totalPage = date.total;
        this.refreshData(date.list);

      })
    },

    //刷新页面数据
    refreshData(list) {
      if (commonUtils.isObjectNull(list)) {
        return;
      }
      console.log("refreshData", list)
      if (this.activeName == enumsUtil.lessonTemplateIdCF()) {
        this.tableDataBs = [];
        this.tableDataCf = list;
      } else if (this.activeName == enumsUtil.lessonTemplateIdBS()) {
        this.tableDataCf = [];
        this.tableDataBs = list;
      }
      this.refreeTime = new Date().getTime();
    },
    // 重置
    handleResetSearch() {
      this.queryParam = {
        childName: '',
        childPetName: "",
        userPhone: '', //家长手机号
        dayTime: null,

        //分页查询
        pageNum: 1,//当前第几页
        totalPage: 1, //总共数
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
        this.flechList();
    },
    //点击查询按钮
    onBtnSearch() {
      this.flechList();
    },

    handleSizeChange(val) {
      this.queryParam.pageNum = 1;
      this.queryParam.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParam.pageNum = val;
      this.flechList()
    },

    handleClick(val) {
      this.flechList()

    },
    onServiceOk() {
      this.flechList();
    }









  }
}
</script>






// WEBPACK FOOTER //
// src/views/service/after-class-service/index.vue